
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.7 22.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.3 19.7l-4.2-4.3c1.3-1.4 2.1-3.2 2.1-5.3 0-4.2-3.4-7.7-7.6-7.7C6.4 2.4 3 5.9 3 10.1s3.4 7.7 7.6 7.7c1.6 0 3.1-.5 4.3-1.4 0 0 0 .1.1.1l4.2 4.3c.1.1.3.2.5.2s.4-.1.6-.2c.3-.3.3-.8 0-1.1zM4.5 10.1C4.5 6.7 7.3 4 10.6 4s6.1 2.8 6.1 6.1c.1 3.4-2.7 6.2-6.1 6.2-3.4 0-6.1-2.8-6.1-6.2z"}})])
          )
        }
      }
    